import ClearIcon from '@mui/icons-material/Clear';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getInfluencerListFordashboard } from '../../pages/dashboard/action';
import { updateDashboard } from '../../pages/dashboard/dashboardSlice';
import { setSearchdata } from '../../utils/common';
import { Button, Chip, Typography, Popper, Avatar } from '@mui/material';
import DeleteIcon from "../../assets/images/icons/X.svg";
import instaIcon from "../../assets/images/icons/instaIcon.svg"
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

const filter = createFilterOptions();
const StyledPopper = styled(Popper)(({ theme }) => ({
    '& .MuiAutocomplete-paper': {
        borderRadius: '12px',
        "& ul": {

            padding: '16px 10px',
            overflow: 'none',
        },
        boxShadow: '0px 0px 29px 0px rgba(0, 0, 0, 0.10)',
    },
}));
const useStyles = makeStyles({
    fadeIn: {
        animation: '$fadeIn 1s ease-in-out forwards',
    },
    '@keyframes fadeIn': {
        from: { opacity: 0, transform: 'translateY(4px)' },
        to: { opacity: 1, transform: 'translateY(0px)' },
    },
});

export default function CustomAuto({ handleChange, values, type }) {
    
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let { filters } = useSelector((state) => state.dashboardSlice)
    const { niches } = useSelector((state) => state.commonSlice);
        let industries = niches?.map((v, i) => {
            return { title: v, id: i + 1 };
        });
    const [isFocused, setIsFocused] = useState(false);
    const [fieldOptions] = useState(industries.filter((v) => !values.categories.map((v) => v?.title).includes(v?.title)))
    const [showAllOptions,setShowAllOptions] = useState(false);
    const [fieldValues, setFieldValues] = useState([]);
    const [open, setOpen] = useState(false);
    React.useEffect(() => {
        if (values.categories?.length > 0) {
            setFieldValues(
                fieldOptions?.filter((v) =>
                    values.categories.some((item) => item.title === v.title)
                )
            );
        } else {
            setFieldValues([]);
        }
    }, [values.categories]);


    const handleEnterKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            const searchValue = event.target.value.trim();

            if (searchValue) {
                let data = { showLoading: true, list: [], filters: { platform: values.platform || "Instagram", name: searchValue }, limit: 30, page: 1, totalCount: 0, };
                dispatch(updateDashboard(data));
                setSearchdata(JSON.stringify({ platform: values.platform || "Instagram", name: searchValue }));
                dispatch(getInfluencerListFordashboard());
                if (type === "dashboard") {
                    navigate("/discover-influencers/listing");
                }
                setOpen(false);
                return false;
            }
        }
    };

    const placeHolderValues = ["categories,", "topics,", "bio keywords #anything!"];
    const [placeHolder, setPlaceHolder] = useState("Type here, ✨")
    const classes = useStyles();
    React.useEffect(() => {
        let index = 0;
        let base = "Type here,";
        let currentWords = [];
        const startLoop = () => {
            const addNext = () => {
                if (index < placeHolderValues.length) {
                    setPlaceHolder(`${base} ${currentWords.join(' ')}`);
                    setTimeout(() => {
                        const newWord = placeHolderValues[index];
                        currentWords.push(newWord);
                        setPlaceHolder(
                            <>
                                {base}
                                {' ' + currentWords.slice(0, -1).join(' ') + ' '}
                                <span className={classes.fadeIn}>
                                    {newWord} ✨
                                </span>
                            </>
                        );
                        index++;
                        setTimeout(addNext, 1000);
                    }, 1000);
                }
                else {
                    setTimeout(() => {
                        base = "Type here,";
                        index = 0;
                        currentWords = [];
                        setPlaceHolder(
                            <span className={classes.fadeIn}>
                                Type here,✨
                            </span>
                        );
                        addNext();
                    }, 1000);
                }
            };

            setTimeout(addNext, 1000);
        };
        if (!isFocused && (!values.categories || values.categories.length === 0)) {
            startLoop();
            index = 0;
            base = "Type here,";
            currentWords = [];
        }

        return () => { };
    }, []);


    return (
        <React.Fragment>
            <Autocomplete
                multiple={true}
                open={open}
                onOpen={() => setOpen(true)}
                onClose={(event, reason) => {
                    // Prevent closing on custom interaction
                    if (reason === 'blur' || reason === 'escape' || reason === 'toggleInput') {
                        setOpen(false);
                    }
                }}
                ListboxProps={{
                    sx: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        padding: '10px',
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        justifyContent: "flex-start",
                        boxShadow: '0px 4px 15px 0px #0000001A',
                    },
                }}

                renderTags={(value, getTagProps) =>
                    value.map((option, index) => {
                        return (
                            <Chip
                                key={option.title || option}
                                avatar={<Avatar alt={option.title} src={`/influncersCategoryIcons/category_icon_${option.id}.svg`} sx={{ height: 20, width: 20 }} />}
                                label={<Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'white' }}>
                                    {(option?.title?.length > 10 ? option?.title?.substring(0, 10) + '...' : option?.title) || option}
                                </Typography>}
                                {...getTagProps({ index })}
                                sx={{
                                    background: 'black !important',
                                    borderRadius: '62px', border: '0px solid #CCCBCB',
                                    padding: "3px 8px", height: '32px'
                                }}
                                deleteIcon={<img src={DeleteIcon} style={{ filter: 'brightness(0) invert(1)', }} alt="delete icon" width={24} height={24} />} // Custom delete icon
                            />
                        )
                    })
                }
                value={fieldValues}
                onChange={(event, newValue) => {
                    if (newValue && newValue.length && newValue[newValue.length - 1].inputValue) {
                        filters = { ...filters };
                        delete filters.categories;
                        let name = newValue?.length > 0 ? newValue?.find((v) => v?.inputValue)?.inputValue : "";
                        let data = { showLoading: true, list: [], filters: { platform: values.platform || "Instagram", name: name }, page: 1, limit: 30, totalCount: 0, }
                        dispatch(updateDashboard(data));
                        dispatch(getInfluencerListFordashboard());
                        if (type === "dashboard") {
                            setSearchdata(JSON.stringify({ platform: values.platform || "Instagram", name: name }));
                            navigate("/discover-influencers/listing");
                        }
                    } else {
                        setFieldValues(newValue);
                        handleChange(event, newValue);

                    }
                }}
                limitTags={2}
                key={fieldOptions?.length}
                defaultValue={fieldOptions}
                filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    if (params.inputValue !== '') {
                        filtered.push({
                            inputValue: params.inputValue,
                            title: `Influencers with the name "${params.inputValue}"`,
                        });
                    }

                    return (showAllOptions ? filtered : filtered.slice(0,8));
                }}

                id="free-solo-dialog-demo"
                options={fieldOptions}
                getOptionLabel={(option) => {
                    if (typeof option === 'string') {
                        return option;
                    }
                    if (option?.inputValue) {
                        return option?.inputValue;
                    }
                    return option?.title;
                }}
                selectOnFocus
                clearOnBlur
                disableCloseOnSelect
                onFocus={() => {setIsFocused(true); setOpen(true) }}
                onBlur={() => {setIsFocused(false) }}
                handleHomeEndKeys
                PopperComponent={StyledPopper}
                renderOption={(props, option, { index }) => {
                    return (
                        <>{index === 0 && (<>
                            <li
                                style={{
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    paddingLeft: '10px',
                                    paddingBottom: '0px',
                                    color: "#444141",
                                    width: '90%', textTransform: 'uppercase', letterSpacing: '0.5px'
                                }}>Suggestions</li>
                            <br />
                        </>
                        )}
                            <li {...props} style={{ padding: '2px 8px', width: 'fit-content', margin: "0 3px", borderRadius: '62px', border: '1px solid #CCCBCB', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}> <img src={`/influncersCategoryIcons/category_icon_${option.id}.svg`} alt={`../../assets/images/influncersCategoryIcons/category_icon_${option.id}`} style={{ height: '20px', width: '20px' }} />&nbsp;<Typography sx={{ fontSize: '12px', fontWeight: '500', color: '#444141', }}>{option.title}</Typography></li>
                            {index === (showAllOptions ? fieldOptions.length - 1 : fieldOptions.slice(0,8).length-1) && (
                                <>
                                    <li>
                                        <Button sx={{ height: '32px', borderRadius: '62px', border: '0px solid #0077FF', textDecoration: 'underline', fontSize: '12px !important', fontWeight: '500 !important', fontFamily: 'var(--family1)', "&:hover": { border: 0, textDecoration: 'underline' } }} onClick={() => {setShowAllOptions(!showAllOptions)}}>{!showAllOptions ? "View More" : "View Less"} </Button>
                                    </li>
                                    <li
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            paddingLeft: '10px',
                                            paddingTop: '10px',
                                            color: "#444141",
                                            width: '100%',
                                        }}
                                    >
                                        <p style={{
                                            marginBottom: '10px', fontSize: "14px !important",
                                            fontWeight: "500 !important",
                                        }}>Top List</p>
                                        <ul style={{ listStyle: 'none', padding: '0', gap: '10px', display: 'flex', flexDirection: 'column', color: '#2B2829' }}>
                                            <li style={{ display: 'flex', gap: '5px', alignItems: 'center' }}><img src={instaIcon} alt="instaicon" width={18} height={18} /><Typography sx={{ fontWeight: '400 !important', fontSize: '14px !important', color: '#2B2829 !important' }}>Top content creator of insatgram</Typography></li>
                                            <li style={{ display: 'flex', gap: '5px', alignItems: 'center' }}><img src={instaIcon} alt="instaicon" width={18} height={18} /><Typography sx={{ fontWeight: '400 !important', fontSize: '14px !important', color: '#2B2829 !important' }}>Top content creator of Instagram creator of Instagram</Typography></li>
                                        </ul></li></>)}</>)
                }}
                clearIcon={<ClearIcon fontSize="small" onClick={() => {
                    setSearchdata(JSON.stringify({ platform: filters.platform }));
                    dispatch(updateDashboard({ list: [], filters: { platform: filters.platform }, page: 1, limit: 20, totalCount: 0 }));
                }} />}
                freeSolo
                renderInput={(params) => <TextField   {...params} label="" onKeyDown={handleEnterKeyPress}
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: (<>{params.InputProps.startAdornment} {values?.categories?.length === 0 && (<>
                            <Typography sx={{
                                fontSize: '14px', fontWeight: 500
                            }}>
                                {values?.categories?.length === 0 && !isFocused && (
                                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                                        {placeHolder}
                                    </Typography>
                                )}
                            </Typography>
                        </>)}</>),
                    }}
                    placeholder="" />}
            />

        </React.Fragment>
    );
}
